import React from 'react'
import RelatedProducts from '../RelatedProducts/RelatedProducts'
export default function MyStore() {
  return (
    <div>
        <div className='mt-5 pt-4'>
            <div className='container'>
         <RelatedProducts/>

            </div>
        </div>
    </div>
  )
}
